import React, { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaFacebookF, FaGoogle, FaTwitter, FaGithub } from "react-icons/fa";

const Login = () => {
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    if (
        (phone === "sachin@tripocationholiday.com" || phone === "prince@tripocationholiday.com") && 
        password === "794487@Ab"
    ) {
        navigate("/dashboard/packageenquiry");
    } else {
        setError("Invalid phone or password. Please try again.");
    }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4 py-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="flex w-full max-w-4xl h-[30rem] bg-gray-800 rounded-lg shadow-lg overflow-hidden"
      >
        {/* Left: Image */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="w-1/2 hidden md:block"
        >
          <img
            src="/black.png"
            alt="Login Visual"
            className="w-full h-full object-cover"
          />
        </motion.div>

        {/* Right: Form */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="w-full md:w-1/2 px-6 py-10 md:p-10 text-white"
        >
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-bold tracking-wide flex items-center justify-center gap-2">
              <span className="bg-blue-600 text-white rounded-md px-2 py-1 text-base">★</span>
              TRIPOCATION
            </h1>
            <p className="mt-2 text-gray-400 text-sm">
              Welcome Back! Enter your phone and password to access admin panel.
            </p>
          </div>

          {/* Form */}
          <form className="space-y-4" onSubmit={handleLogin}>
            <div>
              <label className="text-sm text-gray-400 block mb-1">Phone / Email</label>
              <input
                type="text"
                placeholder="Enter your email"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 text-white rounded-md border border-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="text-sm text-gray-400 block mb-1">Password</label>
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 text-white rounded-md border border-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {error && (
              <p className="text-red-500 text-sm font-medium text-center">{error}</p>
            )}

            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md font-medium transition-all duration-300"
            >
              Log In
            </button>
          </form>

          {/* Footer Links */}
          <div className="mt-6 text-center text-sm text-gray-400">
            <p>
              Forgot your password?{" "}
              <a href="#" className="text-blue-400 hover:underline">
                Reset here
              </a>
            </p>
            <p className="mt-1">
              Don’t have an account?{" "}
              <a href="#" className="text-blue-400 hover:underline">
                Sign Up
              </a>
            </p>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Login;
